import moment from 'moment/moment';

import { Enum } from '~/data/enums';
import { EmployeeProposalDecision } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common/types';
import { CurrentEmploymentSalary } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/data';

import { LegacyProposalRequestProps } from './data/legacyAPI';
export * from './data/index';

export const NON_PRESENT_CONFIG = 'nonPresentConfig';

export const commonEnumOptionFiltering = {
  filterEnumsByCodes: (enums: Enum[], rejectCodes: string[]): Enum[] =>
    enums.filter((e) => !rejectCodes.includes(e.code)),
  rejectCodes: {
    EVENT_FREQUENCY: ['0_BLANK'],
  },
};

export const transformProposalRequestProps = (
  requestProps: LegacyProposalRequestProps,
  employmentId: number,
) => {
  return {
    ...requestProps,
    employmentId: !employmentId ? requestProps.employmentId : employmentId,
  };
};

export const mapDefaultDataUtils = () => {
  const defaultToEmptyString = <T>(value: T): string => {
    const fallback = '';

    switch (typeof value) {
      case 'string':
        return value;
      case 'number':
        return value.toString();
      default:
        return fallback;
    }
  };

  const defaultToNumber = <T>(value: T, fallback: number): number => {
    switch (typeof value) {
      case 'number':
        return value;
      case 'string':
        const n = parseInt(value);
        return !isNaN(n) ? n : fallback;
      default:
        return fallback;
    }
  };

  const defaultToNumberField = <T, F>(
    value: T,
    fallback: number | F,
  ): number | F => {
    switch (typeof value) {
      case 'number':
        return value;
      case 'string':
        const n = parseInt(value);
        return !isNaN(n) ? n : fallback;
      default:
        return fallback;
    }
  };

  const defaultResponsibleHR = <T>(
    value: T,
    defaultHRId?: number,
  ): number | string => {
    const result = defaultToNumber(value, defaultHRId || -1);
    return result === -1 ? '' : result;
  };

  return {
    defaultToNumber,
    defaultToNumberField,
    defaultToEmptyString,
    defaultResponsibleHR,
  };
};

export const mapSubmitDataUtils = (props?: {
  defaultSubmissionDateFormat?: string;
}) => {
  const submissionResponsibleHR = (
    value: number | string | undefined,
  ): number => {
    switch (typeof value) {
      case 'number':
        return value;
      case 'string':
        return parseInt(value);
      default:
        return -1;
    }
  };

  const submissionDateInFormat = (
    date: Date | moment.Moment | number | null | undefined,
    format?: string,
  ) => {
    const f = format || props?.defaultSubmissionDateFormat || 'YYYY-MM-DD';
    return date ? moment(date).format(f) : '';
  };

  //TODO: SHOULD GO GLOBAL GENERAL
  const submissionProposalStatus = (props: {
    isHRUser?: boolean;
    decision?: EmployeeProposalDecision;
  }): string => {
    const { isHRUser, decision } = props;
    switch (decision) {
      case EmployeeProposalDecision.Approve:
        return isHRUser ? 'HR_APPROVED' : 'MANAGER_APPROVED';
      case EmployeeProposalDecision.Reject:
        return isHRUser ? 'HR_REJECTED' : 'MANAGER_REJECTED';
      default:
        return isHRUser ? 'HR_APPROVED' : 'PROPOSED';
    }
  };

  const submissionNumberAsString = (number?: number) => `${number ?? ''}`;

  return {
    submissionResponsibleHR,
    submissionDateInFormat,
    submissionNumberAsString,
    submissionProposalStatus,
  };
};

export const filterActiveEmploymentSalary = (
  employmentId: number | string,
  currentSalary: CurrentEmploymentSalary,
): CurrentEmploymentSalary => {
  return currentSalary.employmentId?.toString() === employmentId.toString()
    ? currentSalary
    : { employmentId: +employmentId, salaryFrequency: '', baseSalary: 0 };
};
